import { create } from 'lodash'
import React from 'react'
import Tappable from 'react-tappable/lib/Tappable';
import SelectorActions from '../../../actions/selector-actions'

import {PureRenderMixin} from 'pure-render-mixin'
import AdobeAnalytics from '../../../utils/adobe-analytics'
import createReactClass from 'create-react-class'


var ProductListItemDuplicate = createReactClass({
	mixins: [PureRenderMixin], //Don't use PureRenderMixin unless you know what you're doing

	duplicateOrderItem: function() {
		$('html, body').animate({scrollTop: '+=100px'}, 1000);
		SelectorActions.duplicateOrderItem(this.props.itemId);
	},

	render: function() {
		return (
			<div className={this.props.className}>
				<Tappable onTap={this.duplicateOrderItem}>
					<div className="ope-product-list__item__duplicate__container">
						<div className="ope-icon ope-icon--duplicate"></div>
						<span className="ope-product-list__item__duplicate__label">{_("Duplicate photo")}</span>
					</div>
				</Tappable>
			</div>
		);
	}
});

export default ProductListItemDuplicate;
